/* ==========================================================================
   SABR — product detail
   Port of the static build's product.js. The hand-rolled size/colour matcher
   is gone: options are resolved against Shopify's variant list by option
   position, which is what makes this work for any product, not just the nine.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-product]');
  if (!root) return;

  function readJSON(sel, fallback) {
    var el = document.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var variants = readJSON('[data-variant-json]', []);
  var strings  = readJSON('[data-product-strings]', {});
  // Shopify HTML-escapes translations ("you&#39;d"); turn them back into text.
  (function (d) {
    Object.keys(strings).forEach(function (k) { d.innerHTML = strings[k]; strings[k] = d.value; });
  })(document.createElement('textarea'));
  var form     = document.querySelector('[data-add-form]');
  var idInput  = document.querySelector('[data-variant-id]');
  var addBtn   = document.querySelector('[data-add]');
  var priceEl  = document.querySelector('[data-price]');
  var index    = 0;

  /* --- options -------------------------------------------------------------- */

  function selection() {
    return Array.prototype.map.call(
      document.querySelectorAll('[data-option-position]'),
      function (group) {
        var on = group.querySelector('[aria-pressed="true"]');
        return on ? on.dataset.value : null;
      }
    );
  }

  function match(sel) {
    return variants.find(function (v) {
      return sel.every(function (value, i) {
        return value === null || v.options[i] === value;
      });
    });
  }

  /** A size can be in stock in one colour and not another, so availability is
   *  judged against the rest of the current selection, not the variant alone.
   *  Returns 'in' | 'out' (exists, sold out) | 'none' (no such variant). */
  function valueState(position, value) {
    var sel = selection();
    sel[position - 1] = value;
    var state = 'none';
    variants.forEach(function (v) {
      var fits = sel.every(function (val, i) { return val === null || v.options[i] === val; });
      if (fits) state = v.available ? 'in' : (state === 'in' ? 'in' : 'out');
    });
    return state;
  }

  /* Sold-out sizes stay selectable (struck through) so the back-in-stock form
     can be offered for them; only combinations that don't exist are disabled. */
  function paintOptions() {
    document.querySelectorAll('[data-option-position]').forEach(function (group) {
      var position = parseInt(group.dataset.optionPosition, 10);
      group.querySelectorAll('[data-value]').forEach(function (b) {
        var state = valueState(position, b.dataset.value);
        b.disabled = state === 'none';
        if (state === 'out') b.setAttribute('data-soldout', '');
        else b.removeAttribute('data-soldout');
      });
    });
  }

  /* Prices come pre-formatted from Liquid — money formatting stays Shopify's. */
  function paintPrice(v) {
    if (!priceEl || !v) return;
    priceEl.innerHTML =
      '<div class="price' + (v.onSale ? ' price--sale' : '') + '">' +
        '<span class="price__now">' + v.priceFormatted + '</span>' +
        (v.onSale ? '<span class="price__was">' + v.compareFormatted + '</span>' : '') +
      '</div>';
  }

  function paintAdd(v) {
    var anyStock = variants.some(function (x) { return x.available; });
    if (!anyStock) {
      addBtn.textContent = strings.soldOut || 'Sold out';
      addBtn.disabled = true;
    } else if (!v) {
      addBtn.textContent = strings.select || 'Select a size';
      addBtn.disabled = true;
    } else if (!v.available) {
      addBtn.textContent = strings.soldOut || 'Sold out';
      addBtn.disabled = true;
    } else {
      addBtn.textContent = strings.add || 'Add to bag';
      addBtn.disabled = false;
    }
    paintNotify(v);
    paintSticky(v);
    paintStock(v);
  }

  /* --- low stock -------------------------------------------------------------
     Only for variants Shopify tracks and stops selling at zero (stock is null
     otherwise, e.g. print-on-demand), so the number is always the real one.  */

  var stockEl = document.querySelector('[data-stock]');

  function paintStock(v) {
    if (!stockEl) return;
    var limit = parseInt(strings.lowStockAt, 10) || 3;
    if (!v || !v.available || v.stock === null || v.stock === undefined || v.stock > limit || v.stock < 1) {
      stockEl.hidden = true;
      return;
    }
    var size = v.options.join(' / ');
    var text = v.stock === 1 ? strings.lowStockOne : strings.lowStock.replace('__N__', v.stock);
    stockEl.textContent = text.replace('__S__', size);
    stockEl.hidden = false;
  }

  /* --- delivery estimate -----------------------------------------------------
     Transit times are the ones on the store's Free shipping rates (Settings →
     Shipping), plus 1–2 business days to process. Countries not listed fall in
     the slowest zone, so the estimate never promises more than the rates do. */

  var ZONES = {
    CA: [3, 7],
    US: [5, 10],
    EU: [7, 14],
    REST: [10, 20]
  };
  var EUROPE = ('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE ' +
                'GB NO CH IS').split(' ');
  var PROCESSING = [1, 2];

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }

  (function paintEta() {
    var el = document.querySelector('[data-eta]');
    if (!el || !strings.eta) return;
    var cc = (el.getAttribute('data-country') || '').toUpperCase();
    var zone = ZONES[cc] || (EUROPE.indexOf(cc) > -1 ? ZONES.EU : ZONES.REST);
    var now = new Date();
    var from = addBusinessDays(now, PROCESSING[0] + zone[0]);
    var to = addBusinessDays(now, PROCESSING[1] + zone[1]);
    var locale = (strings.language || 'en') + '-' + (cc || 'CA');
    var fmt;
    try { fmt = new Intl.DateTimeFormat(locale, { weekday: 'short', month: 'short', day: 'numeric' }); }
    catch (e) { fmt = new Intl.DateTimeFormat('en', { weekday: 'short', month: 'short', day: 'numeric' }); }
    el.textContent = strings.eta
      .replace('__C__', el.getAttribute('data-country-name') || cc)
      .replace('__F__', fmt.format(from))
      .replace('__T__', fmt.format(to));
    el.hidden = false;
  })();

  /* --- back in stock ---------------------------------------------------------
     Klaviyo's client back-in-stock endpoint, keyed by the Shopify variant id.
     Klaviyo's "Back in Stock" flow sends the email when inventory returns.   */

  var notify    = document.querySelector('[data-notify]');
  var notifyForm = document.querySelector('[data-notify-form]');
  var notifyMsg = document.querySelector('[data-notify-msg]');
  var notifyVariant = null;

  function paintNotify(v) {
    if (!notify) return;
    var out = v && !v.available;
    notify.hidden = !out;
    if (out && notifyVariant !== v.id) {
      notifyVariant = v.id;
      notifyForm.classList.remove('is-done');
      notifyMsg.textContent = '';
    }
  }

  if (notifyForm) notifyForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = notifyForm.email.value.trim();
    var btn = notifyForm.querySelector('button');
    function say(t, kind) { notifyMsg.textContent = t; notifyMsg.setAttribute('data-kind', kind); }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say(strings.invalidEmail, 'error'); return; }
    var cfg = window.SABR_KLAVIYO;
    if (!cfg) { say(strings.notifyError, 'error'); return; }
    btn.disabled = true;
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + cfg.companyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          // This endpoint takes the email only — no locale or properties.
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + notifyVariant } } }
      } })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('bis ' + r.status);
        notifyForm.classList.add('is-done');
        say(strings.notifyOk, 'ok');
        // Language goes on through onsite identify; the Back in Stock flows split on it.
        if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email, Language: strings.language });
      })
      .catch(function () { say(strings.notifyError, 'error'); })
      .then(function () { btn.disabled = false; });
  });

  /* --- sticky add bar (phones) ----------------------------------------------
     Mirrors the real button's label and state; tapping it submits the real
     form, or scrolls back to the options when there is nothing to add yet.  */

  var sticky = document.querySelector('[data-sticky]');
  var stickyBtn = document.querySelector('[data-sticky-add]');
  var stickyPrice = document.querySelector('[data-sticky-price]');

  function paintSticky(v) {
    if (!sticky) return;
    stickyBtn.textContent = addBtn.textContent;
    stickyBtn.classList.toggle('is-off', addBtn.disabled);
    if (v && stickyPrice) stickyPrice.innerHTML = v.priceFormatted;
  }

  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      sticky.toggleAttribute('data-show', !visible);
      sticky.setAttribute('aria-hidden', String(visible));
    }).observe(addBtn);

    stickyBtn.addEventListener('click', function () {
      if (!addBtn.disabled) {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      } else {
        var target = notify && !notify.hidden ? notify : document.querySelector('[data-options]');
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  /* --- recommendations ------------------------------------------------------- */

  var recsMount = document.querySelector('[data-recs-mount]');
  if (recsMount && window.fetch) {
    fetch(recsMount.dataset.url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var recs = doc.querySelector('[data-recs]');
        if (!recs) return;
        // Cards fade in via chrome.js's reveal observer, which ran before these existed.
        recs.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
        recsMount.appendChild(recs);
      })
      .catch(function () {});
  }

  function sync() {
    var v = match(selection());
    paintOptions();
    paintPrice(v);
    paintAdd(v);
    if (v) {
      idInput.value = v.id;
      // Keep the address bar honest so a shared link opens the same variant.
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
  }

  document.querySelector('[data-options]').addEventListener('click', function (e) {
    var guide = e.target.closest('[data-guide]');
    if (guide) return openModal();

    var b = e.target.closest('[data-value]');
    if (!b || b.disabled) return;
    var group = b.closest('[data-option-position]');
    group.querySelectorAll('[data-value]').forEach(function (x) {
      x.setAttribute('aria-pressed', String(x === b));
    });
    sync();
  });

  /* --- gallery -------------------------------------------------------------- */

  var stage = document.querySelector('[data-stage]');
  var images = stage ? stage.querySelectorAll('img') : [];

  function paintGallery() {
    images.forEach(function (img, i) {
      if (i === index) img.setAttribute('data-active', '');
      else img.removeAttribute('data-active');
    });
    document.querySelectorAll('[data-thumb]').forEach(function (b, i) {
      b.setAttribute('aria-current', String(i === index));
    });
  }

  function step(delta) {
    if (!images.length) return;
    index = (index + delta + images.length) % images.length;
    paintGallery();
  }

  var prev = document.querySelector('[data-prev]');
  var next = document.querySelector('[data-next]');
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });

  var thumbs = document.querySelector('[data-thumbs]');
  if (thumbs) thumbs.addEventListener('click', function (e) {
    var b = e.target.closest('[data-thumb]');
    if (!b) return;
    index = Array.prototype.indexOf.call(b.parentNode.children, b);
    paintGallery();
  });

  document.addEventListener('keydown', function (e) {
    if (document.querySelector('[data-modal][data-open], [data-drawer][data-open]')) return;
    if (e.key === 'ArrowLeft') step(-1);
    if (e.key === 'ArrowRight') step(1);
  });

  /* --- size guide modal ------------------------------------------------------ */

  function openModal() {
    var m = document.querySelector('[data-modal]');
    if (!m) return;
    m.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    var m = document.querySelector('[data-modal]');
    if (!m) return;
    m.removeAttribute('data-open');
    document.body.style.overflow = '';
  }
  var modalClose = document.querySelector('[data-modal-close]');
  if (modalClose) modalClose.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* --- add to bag ------------------------------------------------------------
     Posts to /cart/add.js so the page never reloads; without JS the form still
     submits normally to /cart/add and Shopify redirects to the bag. The same
     call returns the drawer's fresh markup, which then slides open.           */

  form.addEventListener('submit', function (e) {
    if (!window.fetch) return;
    e.preventDefault();
    addBtn.disabled = true;
    var sections = null;

    fetch(window.SABR.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: idInput.value, quantity: 1, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || 'add failed');
        sections = res.body.sections;
        return fetch(window.SABR.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('sabr:cartchange', { detail: { count: cart.item_count } }));
        if (window.sabrDrawer && sections) {
          window.sabrDrawer.paint(sections);
          window.sabrDrawer.open();
        } else if (window.sabrToast) {
          window.sabrToast(strings.added || 'Added to bag');
        }
        addBtn.disabled = false;
      })
      .catch(function (err) {
        // Anything unexpected (sold out between paint and click) falls back to
        // the real form post rather than leaving a dead button.
        addBtn.disabled = false;
        form.submit();
      });
  });

  sync();
  paintGallery();
})();
